import { afterNextRender, Component, signal,OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';

@Component({
 selector: 'iho-pdp-ecolodge-restrooms',
 standalone: true,
    imports: [CommonModule, SharedModule],
 templateUrl: './pdp-ecolodge-restrooms.component.html',
 styleUrls: ['./pdp-ecolodge-restrooms.component.scss'],
})
export class PdpEcolodgeRestroomsComponent implements OnInit {
    resetSwiper = signal(true)
    configSwiperComments: any;
    swiperService = inject(SwiperService);
    dataRestrooms = [
        {
            "title": "پذیرایی",
            "description":"اسپلیت، شوفاژ، طبقه همکف"
        },
        {
            "title": "پذیرایی",
            "description": "اسپلیت، شوفاژ، طبقه همکف"
        },
        {
            "title": "پذیرایی",
            "description": "اسپلیت، شوفاژ، طبقه همکف"
        },
        {
            "title": "سرویس بهداشتی",
            "description": "توالت ایرانی داخل واحد"
        },
        {
            "title": "حمام",
            "description": "دوش / حیاط / رختکن"
        },
        {
            "title": "حمام",
            "description": "دوش / حیاط / رختکن"
        },
        {
            "title": "حمام",
            "description": "دوش / حیاط / رختکن"
        },
    ];
    constructor() {
        afterNextRender(() => {
            this.resetSwiper.set(false)
            setTimeout(() => this.resetSwiper.set(true), 0);
        })
    }
    ngOnInit(): void {
        let config = {
            slide: 'auto',
            pagination: {
                enabled: false,
                clickable: false,
            },
        };
        this.configSwiperComments = this.swiperService.SwiperConfig(config);
    }
}
